module.exports = __webpack_public_path__ + "static/media/excel.a6c31b84.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/excel.svg
// module id = 575
// module chunks = 1